import React from 'react';
import { Link } from 'react-router-dom';

const Breadcrumb = ({ crumbs }) => {
  return (
    <div
      style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '0 5%',
        paddingTop: '96px',
        paddingBottom: '0'
      }}
    >
      <nav
        aria-label="breadcrumb"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0',
          flexWrap: 'wrap'
        }}
      >
        {crumbs?.map((crumb, i) => {
          const isLast = i === crumbs?.length - 1;
          return (
            <React.Fragment key={i}>
              {i > 0 && (
                <span
                  style={{
                    fontFamily: 'JetBrains Mono, monospace',
                    fontSize: '0.625rem',
                    color: 'rgba(138,149,163,0.35)',
                    margin: '0 8px',
                    letterSpacing: '0.05em'
                  }}
                >
                  /
                </span>
              )}
              {isLast ? (
                <span
                  style={{
                    fontFamily: 'JetBrains Mono, monospace',
                    fontSize: '0.6875rem',
                    color: '#F97316',
                    letterSpacing: '0.1em',
                    textTransform: 'uppercase'
                  }}
                >
                  {crumb?.label}
                </span>
              ) : (
                <Link
                  to={crumb?.href}
                  style={{
                    fontFamily: 'JetBrains Mono, monospace',
                    fontSize: '0.6875rem',
                    color: 'rgba(138,149,163,0.55)',
                    textDecoration: 'none',
                    letterSpacing: '0.1em',
                    textTransform: 'uppercase',
                    transition: 'color 150ms ease'
                  }}
                  onMouseEnter={e => { e.currentTarget.style.color = '#EEF0F2'; }}
                  onMouseLeave={e => { e.currentTarget.style.color = 'rgba(138,149,163,0.55)'; }}
                >
                  {crumb?.label}
                </Link>
              )}
            </React.Fragment>
          );
        })}
      </nav>
      <div
        style={{
          height: '1px',
          background: 'rgba(255,255,255,0.04)',
          marginTop: '16px'
        }}
      />
    </div>
  );
};

export default Breadcrumb;
